import { render, staticRenderFns } from "./bIntroSliderView.vue?vue&type=template&id=8baa9014&scoped=true"
import script from "./bIntroSliderView.vue?vue&type=script&lang=js"
export * from "./bIntroSliderView.vue?vue&type=script&lang=js"
import style0 from "./bIntroSliderView.vue?vue&type=style&index=0&id=8baa9014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baa9014",
  null
  
)

export default component.exports